import { useState } from 'react';


const FrontInfo = ({ items,id, scart, setScart }) => {
    const [num, setNewNum] = useState(1);
    const submit = (ev) => {
        if(num>100){setNewNum(1)};
        ev.preventDefault()
        setScart([...scart, {id: id, num: num, info: items}])
        setNewNum(1);
    }
    return (
    <div className="item">
        <div className="imgWrapper">
        <img className="image" alt={items.nimi} src={items.img}></img>
        </div>
        <h2>{items.nimi}</h2>
        <h2>{items.hinta}€</h2>
        <details>
        <summary>Lisätietoja</summary>
        <p>{items.desc}</p>
        </details>
        <div className="ostoNapit" >
        <form onSubmit={submit}>
        <input type="number" min="1" max="100" value={num} onChange={e=>setNewNum(e.target.value)}></input>
        </form>
        <button onClick={submit}>Osta</button>
        </div>
    </div>

    )
}


const FrontItems = ({tuotteet, scart, setScart}) => {
    let front = tuotteet.map((info, id) =>
    <FrontInfo key={id} id={id} items={info} scart={scart} setScart={setScart} />
    )
    return(
        <div className="storeItem">
            {front}
        </div>
    )
}


export { FrontItems};